import { render } from "./forgotPass.vue?vue&type=template&id=48b7fcad"
import script from "./forgotPass.vue?vue&type=script&lang=js"
export * from "./forgotPass.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\dmart\\Desktop\\Mi codigo\\maneiros_v2\\dotaappnofactu\\jano\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__